export * from "./blackfair-brand.component";
